import '../../../css/web/UserModalRenew.css'
import useTheme from '../layoutscommon/DarkModeStorage'
import React, {useRef} from "react";
import '../../../css/web/BtorageGlobalModal.css'
import {useTranslation} from "react-i18next";
import commonTerms from "../../../assets/img/commonTerms.png";
import commonClose from "../../../assets/img/commonClose.png";

function CardRefundPolicy({closeCardPolicyPopup}) {
    const {t} = useTranslation();
    const [theme] = useTheme();
    const scrollViewRef = useRef(null);
    const platformType = window.navigator.userAgent.includes('Mobi') ? '2' : '1';
    const modalWidth = platformType === '2' ? 350 : 400;





    return (
        <div className="btorage-pay-modal-container md-scope" data-theme={theme}>
            <div
                className="btorage-pay-modal-frame ht-600 display-flex flex-column overflow-hidden"
                style={{width: `${modalWidth}px`, background: "#fff",}}>

                {/* 헤더 */}
                <div className="ht70 display-flex align-center justify-content-between pd10"
                    style={{height: 70, flexShrink: 0, borderBottom: "solid 1px #EAEAEA",}}>
                    <div className="user-center">
                        <div className="ht-100pc display-flex just-cont-center align-center">
                            <img className="wd-30 ht-30" alt="terms" src={commonTerms}/>
                        </div>
                        <div className="ht-100pc display-flex align-center">
                            <p className="font-t-title font-s-14 m-l-10 mt-1">{t("bpmTx20")}</p>
                        </div>
                    </div>
                    <div onClick={closeCardPolicyPopup} className="c-point">
                        <img className="wd-30 ht-30" style={{opacity: 0.6}} alt="close" src={commonClose}/>
                    </div>
                </div>

                {/* 바디 */}
                <div className="font-t-cont font-s-13" style={{flex: 1, overflowY: "auto", padding: 16}}>
                    <div>

                        <div>
                            <p className="font-b">{t("bpmTx22")}</p>
                            <p className="ws-pre-line m-t-5">{t("bpmTx23")}</p>
                        </div>

                        <div className="m-t-30">
                            <p className="font-b">{t("bpmTx24")}</p>
                            <p className="ws-pre-line m-t-5">{t("bpmTx25")}</p>
                        </div>

                        <div className="m-t-30">
                            <p className="font-b">{t("bpmTx26")}</p>
                            <p className="ws-pre-line m-t-5">{t("bpmTx27")}</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default CardRefundPolicy
